import { Component, OnInit } from '@angular/core';
import { EstadoService } from '../../_services/estado.service';
import { Estado } from '../../_models/estado';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { EstadoRolService } from '../../_services/estado-rol.service';
import { forkJoin } from 'rxjs';
import { EstadoRol } from '../../_models/estado-rol';
import { NavService } from '../../_services/_nav.service';
import { EstadoCausal } from '../../_models/estado-causal';
import { EstadoCausalService } from '../../_services/estado-causal.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EstadoAdjuntoService } from '../../_services/estado-adjunto.service';
import { AdjuntoService } from '../../_services/adjunto.service';

@Component( {
  selector: 'app-estados-detalle',
  templateUrl: 'estados-detalle.component.html'
} )

export class EstadosDetalleComponent implements OnInit {

  estado: Estado;
  lisEstadoRol: EstadoRol[] = [];
  lisEstadoCausal: EstadoCausal[] = [];
  carInformacionInicial = true;
  columnas: any[] = [];
  colCausal: any[] = [];
  carImagen = false;
  imagen: SafeResourceUrl;

  constructor( private estServicio: EstadoService,
               private estRolServicio: EstadoRolService,
               private navServicio: NavService,
               private estCausalService: EstadoCausalService,
               private estAdjuntoService: EstadoAdjuntoService,
               private adjService: AdjuntoService,
               private sanitizer: DomSanitizer,
               private route: ActivatedRoute, private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreRol', header: this.navServicio.buscarMensaje( 'ESTADOSROL.LBL_ROL' ), sort: false }
    ];

    this.colCausal = [
      { field: 'causalSolicitud', header: this.navServicio.buscarMensaje( 'ESTADOSCAUSAL.LBL_NOMBRECAUSAL' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.estServicio.obtenerPorId( params[ 'id' ] ),
        this.estRolServicio.listadoPorEstado( params[ 'id' ] ),
        this.estCausalService.listadoPorEstadoHabilitado( params[ 'id' ] ),
        this.estAdjuntoService.obtenerPorEstado(params[ 'id' ]),
        this.estServicio.listado()).subscribe( ( [ estado, estRoles, estCausal, adjunto, estados ] ) => {
        this.estado = estado;
        if ( this.estado && this.estado.idEstadoAnterior && (this.estado.indicadorCambioEstado || this.estado.indicadorCambioEstadoDigital) ) {
          this.estado.nombreEstadoAnterior = estados.find( x => x.idEstado === this.estado.idEstadoAnterior ).nombreEstado;
          this.estado.nombreEstadoAnteriorDigital = estados.find( x => x.idEstado === this.estado.idEstadoAnteriorDigital ).nombreEstado;
        } else {
          this.estado.nombreEstadoAnterior = this.estado.nombreEstado;
        }

        this.lisEstadoRol = estRoles.filter( x => x.indicadorHabilitado );
        this.lisEstadoCausal = estCausal;
        if ( adjunto && adjunto.indicadorHabilitado ) {
          this.cargarAdjunto( adjunto.idAdjunto );
        }
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarAdjunto( idAdjunto: string ) {
    this.carImagen = true;
    this.adjService.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      this.cargarReaderImagen( adjunto );
      this.carImagen = false;
    }, error => {
      this.carImagen = false;
    } );
  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  regresar() {
    this.location.back();
  }
}
